import React, { useEffect } from "react";

const TONE_STYLES = {
  success: "bg-emerald-500/90 text-white",
  error: "bg-red-500/90 text-white",
  info: "bg-gray-700/90 text-white",
  warning: "bg-amber-500/90 text-gray-900",
};

export function SupportToast({ toast, onDismiss }) {
  useEffect(() => {
    if (!toast) return undefined;
    const timeout = setTimeout(() => {
      onDismiss?.();
    }, 4000);
    return () => clearTimeout(timeout);
  }, [toast, onDismiss]);

  if (!toast) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <div
        className={`flex items-center gap-3 px-4 py-3 rounded-lg shadow-lg text-sm ${
          TONE_STYLES[toast.tone] || TONE_STYLES.info
        }`}
        role="status"
      >
        <span>{toast.message}</span>
        <button
          type="button"
          onClick={onDismiss}
          className="text-white/80 hover:text-white transition"
          aria-label="Dismiss notification"
        >
          ✕
        </button>
      </div>
    </div>
  );
}

export function statusBadgeClass(status) {
  switch (status) {
    case "open":
      return "bg-blue-500/20 text-blue-200 border border-blue-400/40";
    case "awaiting_support":
      return "bg-purple-500/20 text-purple-200 border border-purple-400/40";
    case "awaiting_user":
      return "bg-amber-500/20 text-amber-200 border border-amber-400/40";
    case "resolved":
      return "bg-emerald-500/20 text-emerald-200 border border-emerald-400/40";
    case "closed":
      return "bg-gray-500/20 text-gray-200 border border-gray-400/40";
    default:
      return "bg-gray-500/20 text-gray-200 border border-gray-400/40";
  }
}
